import React from "react";
import { Empty, List, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import * as uuid from "uuid";
import { CompositeField, Visibility } from "../../../../../components/shared";
import { ContestListItem } from "./contest-list-item";

export function ContestsInput({ onChange, value, viewMode = false }) {
  const onItemChange = ({ contest, values, idx, replaceItemAtIndex }) => {
    values.uid = contest.uid;
    replaceItemAtIndex(idx, values);
  };

  return (
    <CompositeField
      onChange={onChange}
      isAddDisabled={true}
      value={value}>
      {({items, addNew, removeItem, replaceItemAtIndex}) => {
        return (
          <>
            <List>
              { (items.length === 0) ?
                <Empty />
              : items.map((contest, idx) => (
                <List.Item key={`contest-item-${contest.uid}`}>
                  <ContestListItem
                    contest={contest}
                    idx={idx}
                    viewMode={viewMode}
                    onChange={values =>
                      onItemChange({contest, values, idx, replaceItemAtIndex})}
                    removeItem={removeItem} />
                </List.Item>
                )
              )}
            </List>
            <Visibility
              visible={!viewMode}>
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() => addNew({ uid: uuid.v4() })}
                block>
                Agregar concurso
              </Button>
            </Visibility>
          </>);
        }
      }
    </CompositeField>
  );
}
